import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-subtitle-1 mr-4" }

import { useRouter } from 'vue-router';
import { msalInstance } from '@/auth/msalInstance';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'TopBar',
  emits: ['logout'],
  setup(__props, { emit: __emit }) {

const router = useRouter();
const colors = {
  PRIMARY: '#714FE3'
};

// Get user's given name from MSAL account
const userName = computed(() => {
  const accounts = msalInstance.getAllAccounts();
  return accounts.length > 0 ? accounts[0].idTokenClaims?.given_name || '' : '';
});

// Define emits
const emit = __emit;

const handleLogout = async () => {
  try {
    emit('logout');
  } catch (error) {
    console.error('Logout failed:', error);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_app_bar_title = _resolveComponent("v-app-bar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createBlock(_component_v_app_bar, {
    app: "",
    color: colors.PRIMARY,
    dark: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_app_bar_title, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            variant: "text",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/'))),
            class: "text-h6 text-white pa-0"
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode(" 1stopVAT Walmart Portal ")
            ])),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_spacer),
      _createElementVNode("span", _hoisted_1, _toDisplayString(userName.value), 1),
      _createVNode(_component_v_menu, { "offset-y": "" }, {
        activator: _withCtx(({ props }) => [
          _createVNode(_component_v_btn, _mergeProps({ icon: "" }, props, { class: "ml-2" }), {
            default: _withCtx(() => [
              _createVNode(_component_v_avatar, {
                color: "secondary",
                size: "36"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                      _createTextVNode("mdi-account")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 2
          }, 1040)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_v_list, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item, { onClick: handleLogout }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                      _createTextVNode("Logout")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["color"]))
}
}

})